import { transition, trigger, useAnimation } from '@angular/animations';
import { Component, OnInit, Input } from '@angular/core';
import { slideInDown, slideOutDown } from 'ng-animate';
import { EventsService, UtilService, VariablesService } from '../../../../shared/services';

@Component({
  selector: 'app-impact-docker',
  templateUrl: './impact-docker.component.html',
  styleUrls: ['./impact-docker.component.scss'],
  animations: [
    trigger('slide', [
      transition(':enter', [useAnimation(slideInDown, {
        params: { timing: 0.3 }
      })]),
      transition(':leave', [useAnimation(slideOutDown, {
        params: { timing: 0.3 }
      })])
    ])
  ],
})
export class ImpactDockerComponent implements OnInit {

  @Input() elementId = 'donation-form';
  @Input() text = 'You’ve been a part of this great journey, let’s create more impact together';
  @Input() btnLabel = 'Create More Impact';
  @Input() icon = true;
  @Input() isDonated = true;
  @Input() updateId;
  @Input() top;
  @Input() config;

  constructor(
    public utilService: UtilService,
    public vars: VariablesService,
    public eventService: EventsService
  ) { }

  ngOnInit() {
  }

  events() {
    this.utilService.scrollIntoViewSmoothly(this.elementId, this.top);
    if (this.config?.event) {
      this.eventService.sendSystemEvent({
        eventName: this.config?.event
      }).subscribe(_ => _);
    }
  }

}
